.disabled {
  opacity: 0.5;
  cursor: not-allowed;

  * {
    pointer-events: none;
    cursor: not-allowed;
    user-select: none;
    -webkit-user-select: none;
    cursor: not-allowed;
    user-select: none;
  }
}

.hidden {
  display: none;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
